var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "hotel_calendar--footer" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "footer--close",
        attrs: { title: "Click to close the calendar", href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.closeCalendar.apply(null, arguments)
          },
        },
      },
      [_vm._v("Close")]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "footer--legend" }, [
      _c("span", { staticClass: "legend--item legend--item-special_offer" }, [
        _vm._v(" Special"),
        _c("span", { staticClass: "mobile-hidden" }, [_vm._v(" Offer")]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "legend--item legend--item-day_highlight" }, [
        _c("span", { staticClass: "mobile-hidden" }, [_vm._v(" Date")]),
        _vm._v(" Selected"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }